module.exports = __webpack_public_path__ + "static/media/4.85a91bdd.jpg";